'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var styled = require('styled-components');
var Tippy = require('@tippyjs/react');
require('tippy.js/dist/tippy.css');
var components_Caption_index = require('../Caption/index.js');
var constants_properties = require('../../constants/properties.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var Tippy__default = /*#__PURE__*/_interopDefaultLegacy(Tippy);

var StyleTippy = styled__default["default"](Tippy__default["default"])(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  border-radius: 7px;\n  background-color: ", ";\n  padding: 6px 8px;\n"], ["\n  border-radius: 7px;\n  background-color: ", ";\n  padding: 6px 8px;\n"])), function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
});
var TitleContainer = styled__default["default"](components_Caption_index["default"])(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var light = _a.theme.colors.text.light;
    return light;
});
var Tooltip = function (_a) {
    var text = _a.text, children = _a.children, _b = _a.placement, placement = _b === void 0 ? constants_properties.TooltipPlacement.BOTTOM : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    return (React__default["default"].createElement(StyleTippy, { content: React__default["default"].createElement(TitleContainer, null, text), placement: placement, disabled: disabled, arrow: true }, children));
};
var templateObject_1, templateObject_2;

exports["default"] = Tooltip;
